import { COMMON_ERRORS } from "./common.js";
import { EVENT_ERRORS } from "./event.js";
import { WORKFLOW_ERRORS } from "./workflow.js";
import { CONNECTOR_ERRORS } from "./connector.js";
import { AGENT_ERRORS } from "./agent.js";
import { API_ERRORS } from "./api.js";
/**
 * Central error registry — merged from the per-service catalogs. Each service
 * owns its own codes; this is the single lookup surface that feeds response
 * bodies, the `fastn_errors_total` metric, and trace spans. Canonical codes are
 * service-prefixed (EVT-/WF-/CONN-/AGT-/API-); the legacy flat codes remain as
 * aliases so every existing response body and the HTTP-status fallback resolve.
 */
export const ERROR_REGISTRY = {
    ...COMMON_ERRORS,
    ...EVENT_ERRORS,
    ...WORKFLOW_ERRORS,
    ...CONNECTOR_ERRORS,
    ...AGENT_ERRORS,
    ...API_ERRORS,
};
const FALLBACK_ENTRY = {
    message: "Unknown error",
    severity: "error",
    status: 500,
    service: "common",
};
/** Look up canonical message + severity + status + service. Generic fallback for unknown codes. */
export function lookupError(code) {
    return ERROR_REGISTRY[code] ?? FALLBACK_ENTRY;
}
//# sourceMappingURL=registry.js.map